module.exports = __webpack_public_path__ + "9402b736cb6d2c3fbaaf598b7cb266e0.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Italic.woff
// module id = 703
// module chunks = 0